import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { createApiClient } from '../../api/client';
import { useCaseContext } from '../context/CaseContext';
import '../mobile.css';

const inputStyle = {
  width: '100%',
  boxSizing: 'border-box',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: '#ccc',
  borderRadius: '8px',
  padding: '12px',
  marginBottom: '12px',
  fontFamily: 'inherit',
  fontSize: '14px',
};

const NewAccused = ({ API_URL }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { fullFIR, setFullFIR } = useCaseContext();
  const fir = location.state?.fir || fullFIR;

  const [gender, setGender] = useState('');
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [relationshipWithComplainant, setRelationshipWithComplainant] = useState('');

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const isDisabled = loading || !gender || !name.trim() || !role.trim();

  const handleSubmit = async () => {
    setLoading(true);
    setErrorMessage('');

    try {
      const api = createApiClient(API_URL);
      const response = await api.post('/fir/accused', {
        firId: fir.id,
        gender,
        name: name.trim(),
        role: role.trim(),
        relationshipWithComplainant: relationshipWithComplainant.trim(),
      });
      setFullFIR(response.data);
      navigate('/m/fir/accused', { state: { fir: response.data } });
    } catch {
      setErrorMessage('Failed to add accused. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!fir) return <p style={{ textAlign: 'center', fontWeight: 700 }}>No case data available.</p>;

  return (
    <div>
      <h2 style={{ fontSize: '20px', fontWeight: 700, color: '#094268', marginBottom: '15px' }}>Add Accused</h2>

      <div style={{ marginBottom: '2px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <div style={{ fontSize: '16px', fontWeight: 600, color: '#333', marginBottom: '6px' }}>Gender</div>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={gender === 'Male'}
              onChange={() => setGender(gender === 'Male' ? '' : 'Male')}
              style={{ width: '16px', height: '16px', margin: 0, flexShrink: 0 }}
            />
            Male
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={gender === 'Female'}
              onChange={() => setGender(gender === 'Female' ? '' : 'Female')}
              style={{ width: '16px', height: '16px', margin: 0, flexShrink: 0 }}
            />
            Female
          </label>
        </div>
      </div>

      <input
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        style={inputStyle}
      />

      <input
        placeholder="Role (crime committed by accused)"
        value={role}
        onChange={(e) => setRole(e.target.value)}
        style={inputStyle}
      />

      <textarea
        placeholder="Relation with Victim (optional)"
        value={relationshipWithComplainant}
        onChange={(e) => setRelationshipWithComplainant(e.target.value)}
        rows={2}
        style={inputStyle}
      />

      <button onClick={handleSubmit} disabled={isDisabled} className="m-button-primary">
        {loading ? <div className="m-spinner" style={{ margin: '0 auto' }} /> : 'Submit'}
      </button>

      {errorMessage && (
        <div className="m-popup-overlay">
          <div className="m-popup-container">
            <h3>Error</h3>
            <p>{errorMessage}</p>
            <button className="m-button-primary" onClick={() => setErrorMessage('')}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewAccused;
